import React from "react";
import MultiSelectAutoCompleteGroupCompany from "../../Company360/components/MultiSelectAutoCompleteGroupCompany";
import { Company, CompanySegment, Industry, Sector } from "../../../core/api/models";
import { Control, Controller, DeepMap, FieldError } from "react-hook-form";
import ErrorMessage from "../../../components/text/ErrorMessage";
import Countries from "../../../utils/countries.json";
import { DateInput } from "../../../components/form-group";
import { DropdownList, Multiselect } from "react-widgets";

interface CreateCompanyGeneralFormProps {
    classOptions: { value: string; name: string; }[];
    companySegments: CompanySegment[];
    companyTypeOptions: { name: string; value: string; }[];
    control: Control<Company>;
    errors: DeepMap<Company, FieldError>;
    industries: Industry[];
    ROCOptions: { name: string; value: string; }[];
    sectors: Sector[];
    selectedValues: { tenantsName: string; tenantsID: number; }[];
    setSelectedValues: React.Dispatch<React.SetStateAction<{ tenantsName: string; tenantsID: number; }[]>>;
    validateProtocol: (value?: string | undefined) => true | "Please enter a URL with http:// or https://" | "Please enter a valid URL";
}


export function CreateCompanyGeneralForm({ classOptions,
    companySegments,
    companyTypeOptions,
    control,
    errors,
    industries,
    ROCOptions,
    sectors,
    selectedValues,
    setSelectedValues,
    validateProtocol }: CreateCompanyGeneralFormProps) {
    return (
        <>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Company/Organization:<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    rules={{
                        required: {
                            value: true,
                            message: 'Company Name is required'
                        }
                        // validate: (value) => {
                        //   return !!value.trim();
                        // },
                    }}
                    name={"name"}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder={'Company Name'}
                            name={name}
                            value={value}
                            onChange={onChange}
                        // onKeyDown={onFieldUpdate}
                        // id={props.property}
                        />
                    )}
                />
                {errors.name && <ErrorMessage>{errors.name.message}</ErrorMessage>}
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Website:
                </label>
                <Controller
                    control={control}
                    name="websiteUrl"
                    rules={{
                        // required: 'Please enter the website URL',
                        validate: (value) => {
                            return validateProtocol(value);
                        },
                    }}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Company Website"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="websiteUrl"
                        />
                    )}
                />
                {errors.websiteUrl && <ErrorMessage>{errors.websiteUrl.message}</ErrorMessage>}
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Industry:
                </label>
                <Controller
                    control={control}
                    name="industryId"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            // value={changeValue ? value : companyDetails?.industry?.name}
                            value={value}
                            defaultValue={value}
                            data={industries?.map((key) => {
                                return {
                                    _id: key._id,
                                    name: key.name,
                                };
                            })}
                            textField={"name"}
                            valueField={"_id"}
                            placeholder={"Select Industry"}
                            onChange={(val) => {
                                // setChangeValue(true);
                                onChange(val._id);
                            }}

                        />
                    )}
                />

                {/* {errors.city && <ErrorMessage>{errors.city.message}</ErrorMessage>} */}
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    CIN Number:<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    name="cinNumber"
                    rules={{
                        required: true,
                        // validate: (value) => {
                        //   return !!ValidateDigitString(value);
                        // },
                        // maxLength: 25,
                    }}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder="CIN Number"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="cinNumber"
                        />
                    )}
                />
                {errors.cinNumber && errors.cinNumber.type === "maxLength" && (
                    <ErrorMessage>
                        CIN Number cannot have more than 25 characters!
                    </ErrorMessage>
                )}
                {errors.cinNumber && errors.cinNumber.type === "validate" && (
                    <ErrorMessage>Invalid CIN Number</ErrorMessage>
                )}
                {errors.cinNumber && errors.cinNumber.type === "required" && (
                    <ErrorMessage>CIN Number is required</ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    PAN Number:
                </label>
                <Controller
                    control={control}
                    name="companyPan"
                    rules={{
                        validate: (value) => {
                            if (value) {
                                const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                return panRegex.test(value);
                            }
                        },
                        // minLength: 10,
                        maxLength: 10,
                    }}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder="PAN Number"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="companyPan"
                        />
                    )}
                />
                {errors.companyPan && errors.companyPan.type === "maxLength" && (
                    <ErrorMessage>
                        PAN No cannot have more than 10 characters!
                    </ErrorMessage>
                )}
                {errors.companyPan && errors.companyPan && (
                    <ErrorMessage>
                        Invalid PAN No
                    </ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    GSTIN Number:
                </label>
                <Controller
                    control={control}
                    name="gstinNumber"
                    rules={{
                        validate: (value) => {
                            if (value) {
                                const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[0-9A-Z]{1}[0-9A-Z]{1}$/i;
                                return regex.test(value);
                                // return !!ValidateDigitString(value);
                            }
                        },
                        maxLength: 15,
                    }}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder="GSTIN Number"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="gstinNumber"
                        />
                    )}
                />
                {errors.gstinNumber && errors.gstinNumber.type === "maxLength" && (
                    <ErrorMessage>
                        GSTIN Number cannot have more than 15 characters!
                    </ErrorMessage>
                )}
                {errors.gstinNumber && errors.gstinNumber.type === "validate" && (
                    <ErrorMessage>Invalid GSTIN Number</ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Country of Origin:<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    rules={{ required: true }}
                    defaultValue={"India"}
                    name="originCountry"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            defaultValue={value}
                            data={Countries}
                            textField={"name"}
                            valueField={"name"}
                            placeholder={"Select country"}
                            onChange={(val) => {
                                onChange(val.name);
                            }}
                            filter={"contains"}
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Incorporation Date:
                </label>
                <Controller
                    control={control}
                    name="incorporatedDate"
                    render={({ onChange, value }) => (
                        <DateInput
                            default={value}
                            placeholder={"Incorporation Date"}
                            onChange={onChange}
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Scale:
                </label>
                <Controller
                    control={control}
                    name="sectorId"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            // value={changeValue ? value : companyDetails?.sector?.name}
                            value={value}
                            data={sectors?.map((key) => {
                                return {
                                    _id: key._id,
                                    name: key.name,
                                };
                            })}
                            textField={"name"}
                            valueField={"_id"}
                            placeholder={"Select Scale"}
                            onChange={(val) => {
                                // setChangeValue(true);
                                onChange(val._id);
                            }}
                        />
                    )}
                />
                {errors.sectorId && <ErrorMessage>Scale is required</ErrorMessage>}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Grade:
                </label>
                <Controller
                    control={control}
                    name="companySegmentId"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            // value={value || companyDetails?.companySegment?.name}
                            value={value}
                            // defaultValue={value}
                            data={companySegments?.map((key) => {
                                return {
                                    _id: key._id,
                                    name: key.name,
                                };
                            })}
                            textField={"name"}
                            valueField={"_id"}
                            placeholder={"Select Grade"}
                            onChange={(val) => {
                                // setChangeValue(true);
                                onChange(val._id);
                            }}
                        />
                    )}
                />
                {errors.companySegmentId && (
                    <ErrorMessage>Grade is required</ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Revenue:
                </label>
                <Controller
                    control={control}
                    name="revenue"
                    render={({ onChange, value, name }) => (
                        <input
                            type="number"
                            min={0}
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Revenue"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="revenue"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Authorized Capital:
                </label>
                <Controller
                    control={control}
                    name="authorisedCapital"
                    render={({ onChange, value, name }) => (
                        <input
                            type="number"
                            min={0}
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Authorized Capital"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="authorisedCapital"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Paid-up Capital:
                </label>
                <Controller
                    control={control}
                    name="paidCapitalAmount"
                    render={({ onChange, value, name }) => (
                        <input
                            type="number"
                            min={0}
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Paid-up Capital"
                            name={name}
                            value={value}
                            onChange={onChange}
                        // id="paidUpCapital"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Certifications:
                </label>
                <Controller
                    name="companyCertifications"
                    control={control}
                    render={({ onChange, value }) => (
                        <Multiselect
                            value={value}
                            data={[]}
                            textField={"name"}
                            valueField={"value"}
                            onChange={(val) => {
                                onChange(val);
                            }}
                            filter="startsWith"

                            placeholder="Type here to search"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Memberships:
                </label>
                <Controller
                    name="membership"
                    control={control}
                    render={({ onChange, value }) => (
                        <Multiselect
                            value={value}
                            data={[]}
                            textField={"name"}
                            valueField={"value"}
                            onChange={(val) => {
                                onChange(val);
                            }}
                            filter="startsWith"
                            placeholder="Type here to search"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Employees In India:
                </label>
                <Controller
                    control={control}
                    name="employeesInIndia"
                    render={({ onChange, value, name }) => (
                        <input
                            type="number"
                            min={0}
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Employees In India"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="employeesInIndia"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Total Employees (Global):
                </label>
                <Controller
                    control={control}
                    name="totalEmployees"
                    render={({ onChange, value, name }) => (
                        <input
                            type="number"
                            min={0}
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Total Employees (Global)"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="totalEmployees"
                        />
                    )}
                />
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Regional Office Address:
                </label>
                <Controller
                    control={control}
                    name="regionalOffice"
                    // rules={{ required: true }}
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            // defaultValue={value}
                            data={[]}
                            textField={"projectDetails"}
                            valueField={"projectDetails"}
                            placeholder={"Select"}
                            onChange={(val) => {
                                onChange(val?.projectDetails);
                            }}
                        />
                    )}
                />
                {/* {errors.regionalofficeaddress && errors.regionalofficeaddress.type === "required" && (
              <ErrorMessage>Regional office address is required</ErrorMessage>
            )} */}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Class:
                </label>
                <Controller
                    control={control}
                    name="class"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            // value={changeValue ? value : companyDetails?.industry?.name}
                            value={value}
                            defaultValue={value}
                            data={classOptions}
                            textField={"name"}
                            valueField={"value"}
                            placeholder={"Select"}
                            onChange={(val) => {
                                // setChangeValue(true);
                                onChange(val.value);
                            }}

                        />
                    )}
                />

                {/* {errors.class && <ErrorMessage>{errors.class.message}</ErrorMessage>} */}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Company Type:
                </label>
                <Controller
                    control={control}
                    name="companyType"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            // value={changeValue ? value : companyDetails?.industry?.name}
                            value={value}
                            defaultValue={value}
                            data={companyTypeOptions}
                            textField={"name"}
                            valueField={"value"}
                            placeholder={"Select"}
                            onChange={(val) => {
                                // setChangeValue(true);
                                onChange(val.value);
                            }}

                        />
                    )}
                />

                {/* {errors.companyType && <ErrorMessage>{errors.companyType.message}</ErrorMessage>} */}
            </div>

            <div className="col-12 mb-2 pb-1">
                <div className="row">
                    <div className="col-md-6">
                        <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                            Activity:
                        </label>
                        <Controller
                            control={control}
                            name="activity"
                            render={({ onChange, value, name }) => (
                                <input
                                    type="text"
                                    className="form-control rounded-sm font-weight-semibold"
                                    placeholder="Activity"
                                    name={name}
                                    value={value}
                                    onChange={onChange}
                                // id="paidUpCapital"
                                />
                            )}
                        />
                    </div>

                    <div className="col-3 mb-2 pb-1">
                        <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                            ROC:
                        </label>
                        <Controller
                            control={control}
                            name="roc"
                            render={({ onChange, value, name }) => (
                                <DropdownList
                                    // value={changeValue ? value : companyDetails?.industry?.name}
                                    value={value}
                                    defaultValue={value}
                                    data={ROCOptions}
                                    textField={"name"}
                                    valueField={"value"}
                                    placeholder={"Select"}
                                    onChange={(val) => {
                                        // setChangeValue(true);
                                        onChange(val.value);
                                    }}

                                />
                            )}
                        />

                        {/* {errors.roc && <ErrorMessage>{errors.roc.message}</ErrorMessage>} */}
                    </div>
                </div>
                {/* {errors.activity && <ErrorMessage>{errors.activity.message}</ErrorMessage>} */}
            </div>

            <div className="col-12 mb-2 pb-1">
                <div className="row">
                    <div className="col-md-6">
                        <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                            Activity Description:
                        </label>
                        <Controller
                            control={control}
                            name="activityDescription"
                            render={({ onChange, value, name }) => (
                                <textarea
                                    rows={3}
                                    className="form-control rounded-sm font-weight-semibold"
                                    placeholder="Activity Description"
                                    // name={name}
                                    value={value}
                                    onChange={onChange}
                                // cols={40}
                                />
                            )}
                        />
                    </div>
                </div>
            </div>

            <div className="col-12 mb-2 pb-1">
                <div className="row">
                    <div className="col-md-6">
                        <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                            Group Companies:
                        </label>
                        <MultiSelectAutoCompleteGroupCompany
                            placeholder="Search Group Companies"
                            setSelectedValues={setSelectedValues}
                            selectedValues={selectedValues}
                        />
                    </div>
                </div>
            </div>

        </>
    );
}
